//此文件用于全局声明使用，例如：多语言组件声明，vconsole声明

global.Intl = require('intl');
window.Intl = require('intl');
